import React from "react";
import styled from "styled-components";
import { UI_CAPTION_DF, colors2 } from "oolib";
import { ArrowBendDownRight } from "@phosphor-icons/react";

/**
 * Follow-up chips under an answer. Each chip carries the anchor it will send
 * (BE buildFollowUps), so a click keeps the next question pinned to the same
 * topic the answer was built from. Rendered in both the streaming bubble
 * (from the `complete` event) and the stored message (from metadata), since
 * the bubble is swapped out on refetch.
 */

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  border: 1px solid ${colors2.grey20};
  background: ${colors2.white};
  color: ${colors2.grey80};
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;

  &:hover:not(:disabled) {
    background: ${colors2.grey5};
    border-color: ${colors2.grey40};
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const FollowUpChips = ({ followUps, onPick, disabled }) => {
  if (!Array.isArray(followUps) || followUps.length === 0 || !onPick) return null;
  return (
    <Row>
      <ArrowBendDownRight size={14} color={colors2.grey40} />
      {followUps.map((chip, i) => (
        <Chip key={`${chip.kind || "chip"}-${i}`} type="button" disabled={disabled} onClick={() => onPick(chip)}>
          <UI_CAPTION_DF>{chip.text}</UI_CAPTION_DF>
        </Chip>
      ))}
    </Row>
  );
};
